var _defs, _circle, _path, _path2, _path3, _path4, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle3, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:url(#radial-gradient-2);}.cls-3{fill:url(#radial-gradient-3);}.cls-4{fill:none;}.cls-5{fill:url(#radial-gradient-4);}.cls-6{fill:url(#radial-gradient-5);}.cls-7{fill:url(#radial-gradient-6);}.cls-8{fill:url(#radial-gradient-7);}.cls-9{fill:url(#radial-gradient-8);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 132.34,
    cy: 142.87,
    r: 11.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 102.12,
    cy: 118.23,
    r: 13.46,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 150.25,
    cy: 133.87,
    r: 51.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9c686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#d4be7d",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#bc9858",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ad8140",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#a77837",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 195.8,
    cy: 152.13,
    r: 40.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ffd392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ffd392",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ffd392",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ffd392",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ffd392",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ffd392",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ffd392",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -1094.58,
    cy: 135.28,
    r: 40.67,
    gradientTransform: "translate(372.78 -29.86) scale(0.16 1.35)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -930.81,
    cy: -9.83,
    r: 40.67,
    gradientTransform: "matrix(0.11, -0.11, 0.95, 0.95, 311.57, 55.06)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 38.71,
    cy: -98.52,
    r: 40.67,
    gradientTransform: "matrix(0, -0.16, 1.35, 0, 328.33, 158.39)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 1246.04,
    cy: -78.83,
    r: 40.67,
    gradientTransform: "matrix(-0.11, -0.11, 0.95, -0.95, 413.25, 219.6)",
    xlinkHref: "#radial-gradient-3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 132.34,
    cy: 142.87,
    r: 9.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.82,142.87a52.28,52.28,0,0,1-1.48,12.25,51.74,51.74,0,0,1,0-24.49A52.25,52.25,0,0,1,133.82,142.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.38,141.83a52.5,52.5,0,0,1,7.62,9.7,51.73,51.73,0,0,1-17.32-17.32A52.66,52.66,0,0,1,133.38,141.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.34,141.4a52.62,52.62,0,0,1,12.25,1.47,51.4,51.4,0,0,1-24.49,0A52.58,52.58,0,0,1,132.34,141.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.3,141.83a53,53,0,0,1,9.7-7.62,51.73,51.73,0,0,1-17.32,17.32A53,53,0,0,1,131.3,141.83Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 102.12,
    cy: 118.23,
    r: 10.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.89,118.23a62.63,62.63,0,0,1-1.77,14.66,61.94,61.94,0,0,1,0-29.32A62.63,62.63,0,0,1,103.89,118.23Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.37,117a63.41,63.41,0,0,1,9.12,11.61,61.75,61.75,0,0,1-20.73-20.72A62.69,62.69,0,0,1,103.37,117Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.12,116.47a63,63,0,0,1,14.66,1.76,61.89,61.89,0,0,1-29.31,0A62.93,62.93,0,0,1,102.12,116.47Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.88,117a62.69,62.69,0,0,1,11.61-9.11,63.41,63.41,0,0,1-9.12,11.61,62.69,62.69,0,0,1-11.61,9.11A62.88,62.88,0,0,1,100.88,117Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76,132.66a4.18,4.18,0,0,0,.12,3.27,4.18,4.18,0,0,1-.79-.72c-5.11-6.19,12.8-10,13.79-10.16C88.37,125.35,76.62,130.18,76,132.66Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M222.5,134.57c-7.67,7-24.68,18.07-59.61,24.28a773.4,773.4,0,0,1-103,10.84c6.62-.36,19.43-1.53,43.28-4.27C154.32,159.54,205.8,147.43,222.5,134.57Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.5,127.8c-9.33-5.15-42.72,3.73-55.9,9.09-13.54,5.5-38.67,7-62.39,5.34S78,136.89,78,136.89c1,.34,2,.57,2.87.78a75.84,75.84,0,0,0,10.62,1.62,260.73,260.73,0,0,0,28.64,1c12.27-.15,24.62-1,36.55-4,9.9-2.49,19.53-5.81,29.52-8,7.83-1.76,15.91-3.35,24-3.37C214,124.87,219.34,125.1,222.5,127.8Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78,136.89a7.44,7.44,0,0,1-1.91-1,1.12,1.12,0,0,0,.14.19"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 195.8,
    cy: 152.13,
    r: 32.93
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.12,152.13a190.27,190.27,0,0,1-5.32,44.3,186.76,186.76,0,0,1,0-88.6A190.38,190.38,0,0,1,201.12,152.13Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M199.56,148.37a190.31,190.31,0,0,1,27.56,35.08A190.36,190.36,0,0,1,192,155.9a189.83,189.83,0,0,1-27.55-35.09A190.31,190.31,0,0,1,199.56,148.37Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M195.8,146.81a190.38,190.38,0,0,1,44.3,5.32,190.38,190.38,0,0,1-44.3,5.32,190.27,190.27,0,0,1-44.3-5.32A190.27,190.27,0,0,1,195.8,146.81Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M192,148.37a190.17,190.17,0,0,1,35.09-27.56,190.17,190.17,0,0,1-27.56,35.09,190.5,190.5,0,0,1-35.08,27.55A190,190,0,0,1,192,148.37Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIcon);
export default __webpack_public_path__ + "static/media/stars_icon.b515eb6acfa888c5677fb210905ebb9b.svg";
export { ForwardRef as ReactComponent };